import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow
} from '@/components/ui/table';
import { Card } from '@/components/ui/card';
import { useCoaches } from '@/data/coach';

import CoachRow from './CoachRow';
import NotFound from '@/components/common/NotFound';

const CoachList = () => {
  const coaches = useCoaches();

  if (coaches.data?.length === 0) {
    return <NotFound title="No Coaches Found" />;
  }

  return (
    <>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Status</TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {coaches.data?.map((coach) => (
              <CoachRow key={coach.id} coach={coach} />
            ))}
          </TableBody>
        </Table>
      </Card>
      <div className="text-center p-4">
        <span className="text-sm text-muted-foreground">
          Total: {coaches.data?.length}
        </span>
      </div>
    </>
  );
};

export default CoachList;
